import script from "./AddNewUserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewUserDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddNewUserDialog.vue?vue&type=style&index=0&id=9ce122ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ce122ce"]])

export default __exports__